export default "__VITE_ASSET__DdHkSj2m__"